import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const dashboardApi = createApi({
  reducerPath: 'dashboardApi',
  keepUnusedDataFor: 0,
  baseQuery: fetchBaseQuery({
    baseUrl: '/Dashboard',
    prepareHeaders: prepareAuthHeaders,
  }),
  endpoints: (builder) => ({
    averageAttendanceStatisticsByFaculties: builder.query({
      query: () => ({
        url: `/AverageAttendanceStatisticsByFaculties`,
        method: 'GET',
      }),
    }),
    averageAttendanceStatisticsByFacultyCourses: builder.query({
      query: () => ({
        url: `/AverageAttendanceStatisticsByFacultyCourses`,
        method: 'GET',
      }),
    }),
    topDisciplinesByAttendance: builder.query({
      query: () => ({
        url: `/TopDisciplinesByAttendance`,
        method: 'GET',
      }),
    }),
    averageAttendanceStatisticsByLessonTypes: builder.query({
      query: (facultyId) => ({
        url: `/AverageAttendanceStatisticsByLessonTypes`,
        method: 'GET',
        params: { facultyId }
      }),
    }),
    averageAttendanceStatisticsByGroupStudentsWithLimit: builder.query({
      query: (groupIdOrName) => ({
        url: `/AverageAttendanceStatisticsByGroupStudentsWithLimit`,
        method: 'GET',
        params: { groupIdOrName }
      }),
    }),
    averageAttendanceStatisticsByEmployees: builder.mutation({
      query: (employeeFullName) => ({
        url: `/AverageAttendanceStatisticsByEmployees?employeeFullName=${employeeFullName}`,
        method: 'POST'
      }),
      invalidatesTags: ['Post'],
    }),
  }),
});

export const { 
  useAverageAttendanceStatisticsByFacultiesQuery,
  useAverageAttendanceStatisticsByFacultyCoursesQuery,
  useTopDisciplinesByAttendanceQuery,
  useLazyAverageAttendanceStatisticsByLessonTypesQuery,
  useLazyAverageAttendanceStatisticsByGroupStudentsWithLimitQuery,
  useAverageAttendanceStatisticsByEmployeesMutation
} = dashboardApi;
